import React from 'react';
import { useHistory } from 'react-router-dom';
import { Typography } from 'antd';
import Box from '../../../../shared/ui/Box';
import Btn, { btnTypes } from '../../../../../../components/btn';
import { useToHousingStockFn } from '../../../../services/toHousingStockFn';
import { searchParamKeys } from '../../../../shared/configs/searchParams';
import styles from './index.module.scss';

const contentEngines = [
  {
    label: 'Номер и тип помещения',
    getValue: (room) => `${room.flat} ${room.typeName}`,
  },
  {
    label: 'Номер помещения по ДДУ',
    getValue: (room) => room.addressDdu ?? 'Не указано',
  },
  {
    label: 'Стадия',
    getValue: (room) => room.stageAddressLifeCycle.name,
  },
  {
    label: 'Этап',
    getValue: (room) => room.stepAddressLifeCycle.name,
  },
  {
    label: 'Вид отделки',
    getValue: (room) => room.addressTypeOfFinish?.name ?? 'Не указан',
  },
];

const Header = ({ room }) => {
  const history = useHistory();

  const toFn = useToHousingStockFn({
    linksCreator: getLinksCreator({ room }),
  });

  const toHousingStock = toFn
    ? () => {
        history.push(toFn(history.location));
      }
    : undefined;

  return (
    <div className={styles.root}>
      <div className={styles.leftCol}>
        {contentEngines.map(({ label, getValue }) => (
          <Block key={label} label={label} content={getValue(room)} />
        ))}
      </div>

      {toHousingStock && (
        <Btn
          type={btnTypes.primary}
          onClick={toHousingStock}
          className={styles.toBtn}
        >
          Перейти в Жилой фонд
        </Btn>
      )}
    </div>
  );
};

export default Header;

function Block({ label, content }) {
  return (
    <Box className={styles.block}>
      <Typography.Text>{label}</Typography.Text>
      <Typography.Text className={styles.blockContent}>
        {content}
      </Typography.Text>
    </Box>
  );
}

function getLinksCreator({ room }) {
  return (location) => {
    const params = new URLSearchParams(location.search);
    const companyId = params.get(searchParamKeys.company);

    return {
      pathname: `/HousingStock/company/${companyId}/houses/${room?.houseId}/flats/${room?.id}`,
      from: `Acceptance${location.search}`,
    };
  };
}
